































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { Services, Apis, Factories } from '@finx/web-repository'

import Moment from 'moment'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import Producao from '@finx/web-repository/src/apis/Legacy/services/Producao'
import ProducaoVuex from '@/store/ProducaoVuex'

@Component

export default class ComponentProducaoFiltro extends Vue {
  dialog: Boolean = true
  calenderDialog: Boolean = false
  calendarAttr = {
    backgroundColor: '',
    borderRadius: 0,
  }

  loadings: any = {
    getFontesPagadorasLoad: false,
    getLocaisExecucoesLoad: false,
    getPacientes: false,
    getMedicos: false,
    getProcedimentos: false,
  }

  fontesPagadoras: [] = []
  locaisExecucoes: [] = []
  pacientes: [] = []
  medicos: [] = []
  procedimentos: [] = []

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  set fontePagadoraFiltro(value) {
    this.ga('producao', 'filtro-fonte-pagadora')
    ProducaoVuex.commit('SET_FONTE_PAGADORA_ID_FILTRO', value)
  }

  get fontePagadoraFiltro() {
    return ProducaoVuex.getters.FONTE_PAGADORA_ID_FILTRO
  }

  set localExecucaoFiltro(value) {
    this.ga('producao', 'filtro-local-execucao')
    ProducaoVuex.commit('SET_LOCAL_EXECUCAO_FILTRO', value)
  }

  get localExecucaoFiltro() {
    return ProducaoVuex.getters.LOCAL_EXECUCAO_FILTRO
  }

  set pacienteIdFiltro(value) {
    this.ga('producao', 'filtro-paciente')
    ProducaoVuex.commit('SET_PACIENTE_ID_FILTRO', value)
  }

  get pacienteIdFiltro() {
    return ProducaoVuex.getters.PACIENTE_ID_FILTRO
  }

  set medicoFiltro(value) {
    this.ga('producao', 'filtro-medico')
    ProducaoVuex.commit('SET_MEDICO_FILTRO', value)
  }

  get medicoFiltro() {
    return ProducaoVuex.getters.MEDICO_FILTRO
  }

  set procedimentoFiltro(value) {
    ProducaoVuex.commit('SET_PROCEDIMENTO_FILTRO', value)
  }

  get procedimentoFiltro() {
    return ProducaoVuex.getters.PROCEDIMENTO_FILTRO
  }

  set ultimosDias(value) {
    this.ga('producao', 'filtro-ultimos-dias')

    if (value === undefined || value === null) {
      ProducaoVuex.commit('SET_ULTIMOS_DIAS_FILTRO', '0')
      this.periodo = { start: '', end: '' }
      return
    }

    if (value < 31) {
      this.ultimosDiasClick(value)
    }

    ProducaoVuex.commit('SET_ULTIMOS_DIAS_FILTRO', value)
  }

  get ultimosDias() {
    return ProducaoVuex.getters.ULTIMOS_DIAS_FILTRO
  }

  set periodo(value) {
    this.ga('producao', 'filtro-periodo')
    if (value) {
      ProducaoVuex.commit('SET_PERIODO_FILTRO', value)
    }
  }

  get periodo() {
    return ProducaoVuex.getters.PERIODO_FILTRO
  }

  get produtoFiltro() {
    return ProducaoVuex.getters.PRODUTO_FILTRO
  }

  get contratoId() {
    return ProducaoVuex.getters.CONTRATO_ID
  }

  get user() {
    return ProducaoVuex.getters.USER
  }

  get dateStart() {
    const date = ProducaoVuex.getters.DATA_INICIAL_PT_BR_FORMATADA
    if (date === '' || date === undefined) return ''
    return date
  }

  get dateEnd() {
    const date = ProducaoVuex.getters.DATA_FIM_PT_BR_FORMATADA
    if (date === '' || date === undefined) return ''
    return date
  }

  async getUser() {
    ProducaoVuex.commit('SET_USER', this.$user.profile)
  }

  clearFields() {
    ProducaoVuex.commit('RESET_PRODUTO_FILTRO')
    this.close()
  }


  enableShowCalenderDialog() {
    this.calenderDialog = true
  }

  limparPeriodo() {
    this.periodo = { start: '', end: '' }
    this.calenderDialog = false
    ProducaoVuex.commit('SET_ULTIMOS_DIAS_FILTRO', '0')
  }

  ultimosDiasClick(dias) {
    this.periodo = { start: Moment().subtract(dias, 'days').toDate(), end: Moment().toDate() }
  }

  async getFontesPagadorasLoad() {
    this.loadings.getFontesPagadorasLoad = true

    const request = await Apis.Legacy.Producao.getFontePagadora()
    const success = Factories.Apis.success(request)

    if (success) {
      this.fontesPagadoras = request.data
    }

    this.loadings.getFontesPagadorasLoad = false
  }

  async getLocaisExecucoesLoad() {
    this.loadings.getLocaisExecucoesLoad = true

    const request = await Apis.Legacy.Producao.getLocalExecucao()
    const success = Factories.Apis.success(request)

    if (success) {
      this.locaisExecucoes = request.data
    }

    this.loadings.getLocaisExecucoesLoad = false
  }

  async getPacientes() {
    this.loadings.getPacientes = true

    const request = await Apis.Legacy.Producao.getProducaoPacientes(this.produtoFiltro)
    const success = Factories.Apis.success(request)

    if (success) {
      const validPacientes = request.data.filter((p: any) => p && typeof p === 'string' && p.trim() !== '')
      this.pacientes = validPacientes
    }

    this.loadings.getPacientes = false
  }

  async getMedicos() {
    this.loadings.getMedicos = true

    const request = await Apis.Legacy.Producao.getProducaoMedicos(this.produtoFiltro)
    const success = Factories.Apis.success(request)

    if (success) {
      const validMedicos = request.data.filter((m: any) => m && m.nome && m.nome.trim() !== '')
      this.medicos = validMedicos
    }

    this.loadings.getMedicos = false
  }

  async getProcedimentos() {
    this.loadings.getProcedimentos = true

    const request = await Apis.Legacy.Producao.getProducaoProcedimentos(this.produtoFiltro)
    const success = Factories.Apis.success(request)

    if (success) {
      const validProcedimentos = request.data.filter((p: any) => p && p.descricao && p.descricao.trim() !== '')
      this.procedimentos = validProcedimentos
    }

    this.loadings.getProcedimentos = false
  }

  async loadSelectAll() {
    this.getFontesPagadorasLoad()
    this.getLocaisExecucoesLoad()
    this.getPacientes()
    this.getMedicos()
    this.getProcedimentos()
  }

  initDate() {
    this.periodo = { start: Moment().subtract(1, 'months').toDate(), end: Moment().toDate() }
  }

  @Emit('close')
  close() {
    ProducaoVuex.commit('SET_PAGE', 1)
  }

  async mounted() {
    await this.getUser()
    // await this.loadSelectAll()
  }
}

